<template>
    <div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label title="来源单据类型">来源单据类型</label>
                </div>
                <div class="form-value">
                    <el-select v-model="stuffImpDto.srcVoucherType" clearable>
                        <el-option v-for="item in devcVoucherTypeList" :label="item.text" :value="item.value"/>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label title="来源单据编号">来源单据编号</label>
                </div>
                <div class="form-value">
                    <el-input v-model="stuffImpDto.srcVoucherNo" placeholder="请输入来源单据编号" title="请输入来源单据编号"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required" title="入库仓库">入库仓库:</label>
                </div>
                <div class="form-value">
                    <el-select v-model="stuffImpDto.warehouseId">
                        <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table class="thin" :data="pageDeviceImpInfoList" :height="tableHeight" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="500" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column label="批次号">
                    <el-table-column prop="batchNo" width="120" :render-header="autoSetBatchNo">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.batchNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.batchNo" :title="rows.row.validateInfo.batchNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.batchNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="定义编码">
                    <el-table-column prop="stuffDefCode" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.stuffDefCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.stuffDefCode" :title="rows.row.validateInfo.stuffDefCode.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.stuffDefCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="耗材描述全称">
                    <el-table-column prop="title" width="250">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.title" :title="rows.row.validateInfo.title.errorMsg"/>
                            <input type="text" v-else :disabled="rows.row.devcDefId != null" style="width:240px" @change="commonChangeEvent" v-model="rows.row.title"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="业务单元">
                    <el-table-column prop="bizUnitName" width="250">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.bizUnitName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.bizUnitName.errorMsg">
                                <span>{{rows.row.bizUnitName}}&nbsp;</span>
                            </div>
                            <span v-else>{{rows.row.bizUnitName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="所属部门">
                    <el-table-column prop="shopName" width="250">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.shopName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.shopName.errorMsg">
                                <span>{{rows.row.shopName}}&nbsp;</span>
                            </div>
                            <span v-else>{{rows.row.shopName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="耗材名称">
                    <el-table-column prop="name" width="250">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.name}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="分类">
                    <el-table-column prop="catName" label="设置" width="150">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.catName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="品牌">
                    <el-table-column prop="brandName" width="150">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.brandName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="型号">
                    <el-table-column prop="model" width="220">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.model}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="规格">
                    <el-table-column prop="fixedSpec" width="220">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.fixedSpec}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="数量" align="center">
                    <el-table-column prop="quantity" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.quantity.validateOk" @change="commonChangeEvent" type="number" style="background-color: #edd28b; width: 90px" size="6" v-model="rows.row.quantity" :min="0" :max="100000" :title="rows.row.validateInfo.quantity.errorMsg"/>
                            <input class="align-right" v-else type="number" size="6" @change="commonChangeEvent" v-model="rows.row.quantity" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="单位">
                    <el-table-column prop="theUnit" width="120">
                        <template slot-scope="rows">
                            <div v-if="rows.row.merchtDevcDef != null">{{rows.row.merchtDevcDef.theUnit}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="入账方式" align="center">
                    <el-table-column prop="acctEnterWay" width="100" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.acctEnterWayText">
                                <el-option v-for="item in acctEnterWayList" :label="item.text" :value="item.text"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="原值(元)" align="center">
                    <el-table-column prop="orgWorth" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.orgWorth.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.orgWorth" style="background-color: #edd28b; width: 90px" :title="rows.row.validateInfo.orgWorth.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.orgWorth" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="责任部门">
                    <el-table-column prop="departName" width="120" :render-header="setDepart">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.departName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.departName.errorMsg">
                                <span>{{rows.row.departName}}</span>
                            </div>
                            <div v-else>{{rows.row.departName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="责任人">
                    <el-table-column prop="principalName" width="200" :render-header="setBathPrincipal">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.principalName.validateOk" class="inline-block" style="background-color: #edd28b; width: 50%;height: 100%" :title="rows.row.validateInfo.principalName.errorMsg">
                                <span>{{rows.row.principalName}}</span>
                            </div>
                            <div class="inline-block" v-else>{{rows.row.principalName}}</div>
                            <a class="swb-btn-link fr inline-block" @click="delPrincipal(rows.row)">清除</a>
                            <a class="swb-btn-link fr inline-block" @click="setPrincipal(rows.row)">设置</a>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="备注">
                    <el-table-column prop="memo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo" :title="rows.row.validateInfo.memo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadDeviceImpModel">导出全部耗材</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDeviceImpModelImport">逐条检查导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateStuffImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openPageRouteUrl, getDefaultPageSizes } from '../../app.conf'
    import { openDepartListForSelectDlg, openDepartStaffListForSelectDlg } from '../orgStruct/selectDlg'
    import { showMerchtDevcDefSelectDlg } from '../devcDef/showDlg'
    import { openComStaffComnSelectDlg } from '../orgStruct/selectDlg'

    import shopStuffApi from '../../api/shopStuff'
    import retailerApi from '../../api/retailer'
    import shopStockApi from '../../api/shopStock'
    import devcDefApi from '../../api/devcDef'
    import devcApi from '../../api/devc'

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);
    import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';
    Vue.regist(SwbDefServicerForSelect);
    import SwbBrandSelect from '../categ/BrandSelect';
    Vue.regist(SwbBrandSelect);
    import SwbShopDeviceImpSetDate from '../retailer/ShopDeviceImpSetDate';
    Vue.regist(SwbShopDeviceImpSetDate);
    import SwbDevcCatList from '../categ/DevcCatList';
    Vue.regist(SwbDevcCatList);

    export default {
        name: 'swb-lowcost-imp-check',
        desc: '机构资产导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDeviceImpInfoList: [],
                stuffImpDto: {
                    retailerShopId: null,
                    originalFileName: null,
                    stuffImpInfoList: [],
                    dumyBrandNames: [],
                    warehouseId: null,
                    warehouseName: null,
                    srcVoucherType: null,
                    srcVoucherNo: null,
                    importRecId: null,
                    ioVoucherId: null
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                retailerInfo: null,
                max_quantity_per_item: 500,
                acctEnterWayList: getEnumList('acctEnterWay'),
                deviceUseStateList: getEnumList('deviceUseState'),
                devcVoucherTypeList: getEnumList('devcVoucherType'),
                warehouseList: [],
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            let theLoading = MsgBox.loading();
            this.stuffImpDto.retailerShopId = this.fileObj.extra.retailerShopId;
            this.stuffImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
            this.stuffImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let stuffImpInfoList = this.fileObj.extra.stuffImpInfoList;
            stuffImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    devcDefId: {validateOk: true},
                    batchNo: {validateOk: true},
                    stuffDefCode: {validateOk: true},
                    title: {validateOk: true},
                    shopName: {validateOk: true},
                    bizUnitName: {validateOk: true},
                    quantity: {validateOk: true},
                    theUnit: {validateOk: true},
                    orgWorth: {validateOk: true},
                    departName: {validateOk: true},
                    principalName: {validateOk: true},
                    memo: {validateOk: true}
                };
            });
            this.stuffImpDto.stuffImpInfoList = stuffImpInfoList;
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDeviceImpInfoList();
            self.getWarehouseList();
            theLoading.close();
        },
        methods: {
            getWarehouseList(){
                let self = this;
                let postData = {};
                let retailerShopId = self.stuffImpDto.retailerShopId;
                if(!Utils.isNoB(retailerShopId)) {
                    postData.filterItems = {
                        retailerShopId: retailerShopId
                    }
                }
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.warehouseList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            commonChangeEvent(){
                this.checkData();
            },
            quantityChangeEvent(value){
                this.checkData();
            },
            getRetailerInfo (){
                let self = this;
                retailerApi.getRetailer({}, function (result) {
                    if(result.type == 'info') {
                        self.retailerInfo = result.data;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            checkData () {
                let self = this;
                let rows = this.stuffImpDto.stuffImpInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                for(let i = 0; i < rows.length; i++) {
                    let stuffImpDto = rows[i];
                    stuffImpDto.validateInfo = {
                        devcDefId: {validateOk: true},
                        batchNo: {validateOk: true},
                        stuffDefCode: {validateOk: true},
                        title: {validateOk: true},
                        shopName: {validateOk: true},
                        bizUnitName: {validateOk: true},
                        quantity: {validateOk: true},
                        orgWorth: {validateOk: true},
                        departName: {validateOk: true},
                        principalName: {validateOk: true},
                        memo: {validateOk: true}
                    };
                    // 检查修正 [批次号]
                    if(!Utils.isNoB(stuffImpDto.batchNo)) {
                        stuffImpDto.batchNo = this.replaceSL(stuffImpDto.batchNo, '');
                        if(stuffImpDto.batchNo.length > 20) {
                            stuffImpDto.validateInfo.batchNo = {
                                validateOk: false,
                                errorMsg: "[批次号]单元长度最大20，当前[" + stuffImpDto.batchNo.length + "]"
                            };
                        }
                    } else {
                        stuffImpDto.validateInfo.batchNo = {
                            validateOk: false,
                            errorMsg: "[批次号]单元不能为空"
                        };
                    }
                    // 检查修正 [耗材定义]
                    if(!Utils.isNoB(stuffImpDto.stuffDefCode)) {
                        stuffImpDto.stuffDefCode = this.replaceSL(stuffImpDto.stuffDefCode, '');
                        if(stuffImpDto.stuffDefCode.length > 20) {
                            stuffImpDto.validateInfo.stuffDefCode = {
                                validateOk: false,
                                errorMsg: "[耗材定义]单元长度最大20，当前[" + stuffImpDto.stuffDefCode.length + "]"
                            };
                        }
                    } else {
                        stuffImpDto.validateInfo.stuffDefCode = {
                            validateOk: false,
                            errorMsg: "[耗材定义]单元不能为空"
                        };
                    }
                    // 检查 [耗材名称]
                    if(!Utils.isNoB(stuffImpDto.title)) {
                        stuffImpDto.title = this.replaceSL(stuffImpDto.title, ' ');
                    }
                    if(Utils.isNoB(stuffImpDto.title)) {
                        stuffImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[耗材名称]单元不可为空"
                        };
                    } else if(stuffImpDto.title.length > 30) {
                        stuffImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[耗材名称]单元长度最大30，当前[" + stuffImpDto.title.length + "]"
                        };
                    }
                    // 检查[设备全称]
                    if(!Utils.isNoB(stuffImpDto.title)) {
                        stuffImpDto.title = this.replaceSL(stuffImpDto.title, ' ');
                    }
                    if(Utils.isNoB(stuffImpDto.title)) {
                        stuffImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[耗材全称]单元不可为空"
                        };
                    } else if(stuffImpDto.title.length > 60) {
                        stuffImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[耗材全称]单元长度最大60，当前[" + stuffImpDto.title.length + "]"
                        };
                    }
                    // 检查 [所属业务单元]
                    if(stuffImpDto.shopId == null && !byItemFlag) {
                        stuffImpDto.validateInfo.bizUnitName = {
                            validateOk: false,
                            errorMsg: "业务单元不可为空并且要与目标业务单元名称一致"
                        };
                    }
                    // 检查 [所属店铺]
                    if(stuffImpDto.shopId == null && !byItemFlag) {
                        stuffImpDto.validateInfo.shopName = {
                            validateOk: false,
                            errorMsg: "所属部门不可为空并且要与目标部门名称一致"
                        };
                    }
                    // 检查 [数量]
                    if(stuffImpDto.durable) {
                        if(!Utils.isNaturalStr(stuffImpDto.quantity, true)) {
                            stuffImpDto.validateInfo.quantity = {
                                validateOk: false,
                                errorMsg: "[数量]单元不能为空并且必须为大于0的整数"
                            };
                        }
                    } else {
                        if(!Utils.isNaturalStr(stuffImpDto.quantity, true) || stuffImpDto.quantity > self.max_quantity_per_item) {
                            stuffImpDto.validateInfo.quantity = {
                                validateOk: false,
                                errorMsg: "[数量]单元不能为空并且必须为 1 ~ " + self.max_quantity_per_item + " 的整数"
                            };
                        }
                    }
                    // 检查修正 [单原值(元)]
                    if(!Utils.isNoB(stuffImpDto.orgWorth)) {
                        if(!Utils.isMoneyStr(stuffImpDto.orgWorth) || stuffImpDto.orgWorth < 0) {
                            stuffImpDto.validateInfo.orgWorth = {
                                validateOk: false,
                                errorMsg: "[原值(元)]单元为 >= 0 的数字"
                            };
                        }
                    }
                    // 检查责任部门 检查责任人
                    if(Utils.isNoB(stuffImpDto.departName)) {
                        if(!Utils.isNoB(stuffImpDto.principalName)) {
                            stuffImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                            stuffImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                        }
                    } else {
                        if(stuffImpDto.departId == null) {
                            stuffImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                            stuffImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                        } else {
                            if(!Utils.isNoB(stuffImpDto.principalName) && stuffImpDto.principalId == null) {
                                stuffImpDto.validateInfo.principalName = {
                                    validateOk: false,
                                    errorMsg: "[责任人]异常,请手动设置"
                                };
                            }
                        }
                    }
                    // 检查修正 [备注]
                    if(!Utils.isNoB(stuffImpDto.memo)) {
                        if(stuffImpDto.memo.length > 60) {
                            stuffImpDto.validateInfo.memo = {
                                validateOk: false,
                                errorMsg: "[备注]单元长度最大60，当前[" + stuffImpDto.memo.length + "]"
                            };
                        }
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.stuffImpDto.stuffImpInfoList = Utils.merge([], rows);
                this.setPageDeviceImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.stuffImpDto.stuffImpInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.deviceImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDeviceImpInfoList: function () {
                let totalRows = this.stuffImpDto.stuffImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                this.pageDeviceImpInfoList = totalRows.slice(start, end);
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDeviceImpInfoList();
            },
            // 导出耗材信息
            downloadDeviceImpModel: function () {
                shopStuffApi.saveStuffImpModelForExport(this.stuffImpDto, function (result) {
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                // 虚拟品牌校验
                if(!Utils.isNoB(this.stuffImpDto.warehouseId)) {
                    self.warehouseList.forEach(function (ware) {
                        if(self.stuffImpDto.warehouseId == ware.id) {
                            self.stuffImpDto.warehouseName = ware.name;
                        }
                    });
                }
                // @date 2019-02-22 16:12 @author libin @desc 增加虚拟导入字段信息
                this.stuffImpDto.virtualFlag = false;
                return this.stuffImpDto;
            },
            setDepart (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                Vue.$showDialog({
                                    title: '责任部门 - 选择',
                                    width: 750,
                                    height: 600,
                                    showCloseBtn: true,
                                    template: '<swb-org-tree  :bizUnitId="bizUnitId" :comFlag="true" :isRadio="true" :deaprtFlag="true"  ref="swb_org_tree"></swb-org-tree>',
                                    data: {
                                        bizUnitId: self.stuffImpDto.retailerBizUnitId
                                    },
                                    okClicked: function () {
                                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                                        if(result.type == "info") {
                                            let selectComInfo = result.data;
                                            self.selectStaffComId = selectComInfo.id;    // 用于选择部门人员
                                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                                self.multipleSelection[i].departId = selectComInfo.id;
                                                self.multipleSelection[i].departName = selectComInfo.name;
                                            }
                                            self.checkData();
                                        } else {
                                            return false;
                                        }
                                    }
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任部门?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].departId = null;
                                        self.multipleSelection[i].departName = null;
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setBathPrincipal (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let departIds = self.multipleSelection.pluck("departId");
                                let departIdList = [];
                                departIds.forEach(function (departId) {
                                    if(!departIdList.contains(departId)) {
                                        departIdList.push(departId);
                                    }
                                });
                                if(departIdList.length > 1) {
                                    MsgBox.warning("请选择相同的责任部门进行批量设置责任人");
                                    return;
                                }
                                let departId = departIdList[0];
                                if(Utils.isNoB(departId)) {
                                    MsgBox.warning("必须选择已设置责任部门的行进行设置责任人");
                                    return;
                                }
                                openComStaffComnSelectDlg(self.selectStaffComId, false, function (resultData, theDlg) {
                                    theDlg.close();
                                    let departStaff = resultData.data || {};
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = departStaff.id;
                                        self.multipleSelection[i].principalName = departStaff.name;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任人?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setPrincipal(row){
                let self = this;
                if(Utils.isNoB(row.departId)) {
                    MsgBox.warning("请先设置责任部门");
                } else {
                    openComStaffComnSelectDlg(self.selectStaffComId, false, function (resultData, theDlg) {
                        theDlg.close();
                        let departStaff = resultData.data || {};
                        if(!Utils.isNoB(departStaff) && departStaff.id > 0) {
                            row.principalId = departStaff.id;
                            row.principalName = departStaff.name;
                        }
                        self.checkData();
                    });
                }
            },
            delPrincipal(row){
                row.principalId = null;
                row.principalName = null;
                this.checkData();
            },
            // 批次号
            autoSetBatchNo(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let rows = self.stuffImpDto.stuffImpInfoList.clone();
                                for(let i = 0; i < rows.length; i++) {
                                    let stuffImpDto = rows[i];
                                    if(Utils.isNoB(stuffImpDto.batchNo)) {
                                        let batchNoDate = new Date();
                                        if(!stuffImpDto.durable) {
                                            if(!Utils.isNoB(stuffImpDto.buyDate)) {
                                                batchNoDate = stuffImpDto.buyDate;
                                            } else if(!Utils.isNoB(stuffImpDto.recvDate)) {
                                                batchNoDate = stuffImpDto.recvDate;
                                            }
                                        }
                                        //
                                        stuffImpDto.batchNo = new Date(batchNoDate).format('yyyyMMdd');
                                    }
                                }
                                self.checkData();
                            }
                        }
                    }, '自动生成批次号'),
                ])
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateStuffImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let stuffImpDto = this.stuffImpDto;
                //
                let stuffImpInfoList = stuffImpDto.stuffImpInfoList;
                let srcListLength = stuffImpInfoList.length;
                console.log(srcListLength);
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = stuffImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, stuffImpDto);
                postData.stuffImpInfoList = [srcImpInfo];
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                shopStuffApi.validateStuffImpModel(postData, function (result) {
                    theLoading.hide();
                    if(result.type == 'info') {
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                    }
                    let merchtDevcDef = result.data.stuffImpInfoList[0].merchtDevcDef;  // 一次只检查一条
                    srcImpInfo.merchtDevcDef = Utils.merge({}, merchtDevcDef);
                    stuffImpInfoList[checkNextIndex] = Utils.merge({}, srcImpInfo);
                    stuffImpDto.stuffImpInfoList = Utils.merge([], stuffImpInfoList);
                    self.stuffImpDto = Utils.merge({}, stuffImpDto);
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    self.pageDeviceImpInfoList = Utils.merge([], stuffImpInfoList);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateStuffImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doDeviceImpModelImport(){
                let self = this;
                this.getDlgResult();
                let stuffImpDto = this.stuffImpDto;
                // 判断全部的状态是否是ok
                if(Utils.isNoB(stuffImpDto.warehouseId)) {
                    Toast.show('请选择入库仓库', 2000, 'info');
                    return false;
                }
                if(!Utils.isNoB(stuffImpDto.srcVoucherType) && Utils.isNoB(stuffImpDto.srcVoucherNo)) {
                    Toast.show('请输入来源单据编号', 2000, 'info');
                    return false;
                }
                let srcDeviceImpInfoList = stuffImpDto.stuffImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                if(stuffImpDto.importRecId == null) {
                    if(srcListLength > 500) {
                        //弹出确认框
                        this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            self.validateShopDeviceTitle();
                        }).catch(function () {

                        });
                    } else {
                        self.validateShopDeviceTitle();
                    }
                } else {
                    self.doDeviceImpModelImportStart();
                }
            },
            validateShopDeviceTitle(){
                let self = this;
                let stuffImpDto = this.stuffImpDto;
                stuffImpDto.assetType = 2;
                let theLoading = MsgBox.loading("正在检查同源资产");
                shopStuffApi.validateStuffTitle(stuffImpDto, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let wranMsg = result.data;
                        if(Utils.isNoB(wranMsg)) {
                            self.doDeviceImpModelImportStart();
                        } else {
                            wranMsg = Utils.replace(wranMsg, '\n', '<br/>');
                            let theDlg2 = Vue.$showDialog({
                                title: '提示-确认导入',
                                width: -400,
                                height: -200,
                                okText: '导入',
                                showCloseBtn: true,
                                template: '<div class="simple-form">' +
                                '   <div class="form-group center">' +
                                '        <div class="form-label">' +
                                '            <label></label>' +
                                '        </div>' +
                                '        <div class="form-value">' +
                                '            <span v-html="wranMsg"></span>' +
                                '        </div>' +
                                '    </div>' +
                                '</div>',
                                data: {
                                    wranMsg: wranMsg
                                },
                                methods: {},
                                okClicked: function () {
                                    self.doDeviceImpModelImportStart();
                                },
                                lifecycle: {
                                    created: function () {
                                        MsgBox.warning("部分同源资产描述全称不一致,请确认");
                                    }
                                }
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doDeviceImpModelImportStart(){
                this.startFlag = true;
                let srcDeviceImpDto = this.stuffImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.stuffImpInfoList;
                // let srcListLength = srcDeviceImpInfoList.length;
                //
                let paramDeviceImpDto = {};
                paramDeviceImpDto.retailerId = srcDeviceImpDto.retailerId;
                paramDeviceImpDto.retailerShopId = srcDeviceImpDto.retailerShopId;
                paramDeviceImpDto.retailerBizUnitId = srcDeviceImpDto.retailerBizUnitId;
                paramDeviceImpDto.originalFileName = srcDeviceImpDto.originalFileName;
                paramDeviceImpDto.dumyBrandNames = srcDeviceImpDto.dumyBrandNames;
                paramDeviceImpDto.warehouseId = srcDeviceImpDto.warehouseId;
                paramDeviceImpDto.warehouseName = srcDeviceImpDto.warehouseName;
                paramDeviceImpDto.virtualFlag = srcDeviceImpDto.virtualFlag;
                paramDeviceImpDto.virtualType = srcDeviceImpDto.virtualType;
                paramDeviceImpDto.srcVoucherType = srcDeviceImpDto.srcVoucherType;
                paramDeviceImpDto.srcVoucherNo = srcDeviceImpDto.srcVoucherNo;
                paramDeviceImpDto.importRecId = srcDeviceImpDto.importRecId;
                paramDeviceImpDto.ioVoucherId = srcDeviceImpDto.ioVoucherId;
                //
                this.startDone(paramDeviceImpDto);
            },
            startDone(paramDeviceImpDto){
                let self = this;
                let nextIndex = this.nextIndex;
                let srcDeviceImpDto = this.stuffImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.stuffImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                let srcImpInfo = srcDeviceImpInfoList[nextIndex];
                paramDeviceImpDto.stuffImpInfoList = [srcImpInfo];

                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                paramDeviceImpDto.assetType = 2;
                shopStuffApi.doStuffImpModelImport(paramDeviceImpDto, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if(result.type == 'info') {
                        paramDeviceImpDto.importRecId = resultDto.importRecId;
                        paramDeviceImpDto.ioVoucherId = resultDto.ioVoucherId;
                        if(srcDeviceImpDto.importRecId == null) {
                            srcDeviceImpDto.importRecId = resultDto.importRecId;
                            srcDeviceImpDto.ioVoucherId = resultDto.ioVoucherId;
                        }
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                        console.error(result.message);
                        if(paramDeviceImpDto.importRecId == null) {
                            // 第一条都没过去，记录没生成
                            MsgBox.warning(result.message);
                            return;
                        } else {
                            self.saveShopDeviceImpItemFailed(paramDeviceImpDto, result.message);
                        }
                    }
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (nextIndex + 1) / pageSize;
                    let pageNumber2 = (nextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    if(!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        self.handlePageChange(pageNumber);
                        //
                        if(nextIndex < (srcListLength - 1)) {
                            self.nextIndex = nextIndex + 1;
                            self.startDone(paramDeviceImpDto);
                        } else {
                            self.$emit('other-close', paramDeviceImpDto.importRecId);
                        }
                    }
                });
            },
            saveShopDeviceImpItemFailed(stuffImpDto, errMsg){
                let stuffImpInfoList = stuffImpDto.stuffImpInfoList;
                let deviceImpInfo = stuffImpInfoList[0];
                deviceImpInfo.failDesc = errMsg;
                stuffImpInfoList[0] = deviceImpInfo;
                stuffImpDto.stuffImpInfoList = stuffImpInfoList;
            },
            replaceSL(str, char){
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/shopStuff/LowCostImpCheck.vue